module.exports = ".avatar-center {\r\n  margin-bottom: 47px;\r\n  margin-top: 25px;\r\n  height: 200px;\r\n  width: 200px;\r\n}\r\n\r\n.height-100px {\r\n  height: 100px;\r\n}\r\n\r\n.block-color {\r\n  background-color: #FAFAFA;\r\n}\r\n\r\n.valign-middle {\r\n  vertical-align: middle;\r\n}\r\n\r\na {\r\n  cursor: pointer;\r\n  text-decoration: none;\r\n}\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/components/current-teams/current-teams.component.css
// module id = ./src/app/shared/components/current-teams/current-teams.component.css
// module chunks = main